import * as uuid from 'uuid';
export class TipoNoticia{
    Id: string;
    Description: string;

    Selected: boolean;
    Orden: number;
    Activo: boolean;
    Multiple: boolean;

    Hijos: TipoNoticia[]

    constructor() {
        this.Id = uuid.v4();
        this.Description ="";
        this.Selected = false;
        this.Multiple = false;
        this.Activo = true;
        this.Orden = 0;
        this.Hijos = [];
    }

}



// WEBPACK FOOTER //
// ./src/app/main/models/tipo-noticias/tipo-noticia.ts